import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { RadioButton } from "primereact/radiobutton";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { Calendar } from "primereact/calendar";
import Axios from "../../../api/Axios";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
const EInvoicingDataDownload = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    // /api/SalesReport/eInvoicingDataDownld

    const typeWise = [
        { name: "B2B", key: "B2B" },
        { name: "B2C", key: "B2C" },
    ];
    const [selectedtypeWise, setSelectedTypeWise] = useState(typeWise[0]);
    const nonInvrpt = "SalesReport/eInvoicingDataDownld?";

    const handleExportExcel = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            setLoadingExcel(true);
            const nonInvrptApi = `${nonInvrpt}CompId=${auth.CompId}&FromDate=${fromDateRange}&ToDate=${toDateRange}&cust_type=${selectedtypeWise.key}`;
            let dataresponse = await Axios.get(nonInvrptApi);
            let uniqueNo = `eInvoicingReport${selectedtypeWise.key}${GetDateFormat()}.xlsx`;
            if (dataresponse?.data?.length == 0) {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            } else {
                downloadExcel(dataresponse.data, uniqueNo);
                setLoadingExcel(false);
            }
        } catch (error) {
            setLoadingExcel(false);
            console.log(error);
        }
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">E-Invoicing Data Download</h3>
            <section className="sales-box">
                <form>
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                minDate={date}
                                maxDate={new Date()}
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                minDate={new Date()}
                                maxDate={new Date()}
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label d-block">Customer Type</label>
                            <div className="d-inline-flex">
                                {typeWise.map((doc) => {
                                    return (
                                        <div key={doc.key} className="flex align-items-center">
                                            <RadioButton
                                                inputId={doc.key}
                                                name="doc"
                                                value={doc}
                                                onChange={(e) => setSelectedTypeWise(e.value)}
                                                checked={selectedtypeWise.key === doc.key}
                                            />
                                            <label htmlFor={doc.key} className="mx-2">
                                                {doc.name}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-12">
                            <div className="float-end mt-4">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleExportExcel}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Download"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default EInvoicingDataDownload;
